<template>
    <b-card no-body class="card-container">
        <template v-slot:header>
            <h4 class="mt-0 mb-0">
                Overall statistics <span v-if="!isExport">for</span>
                <b-form v-if="!isExport" inline class="d-inline-block">
                    <b-form-select
                        class="mb-2 mr-sm-2 mb-sm-0"
                        :value="selectedTimeframe"
                        :options="timeframes"
                        v-model="selectedTimeframe"
                    >
                    </b-form-select>
                </b-form>
            </h4>
        </template>

        <b-card-body>
            <div  v-if="!loading && manufacturerStats !== undefined">
                <b-table
                    striped
                    hover
                    bordered
                    small
                    responsive
                    :items="items"
                    :fields="fields"
                    class="table-matrix mb-0"
                >
                    <template v-slot:thead-top>
                        <b-tr class="row-months">
                            <b-th><span class="sr-only">Manufacturer</span></b-th>
                            <b-th
                                v-for="d in manufacturerStats.dates"
                                class="text-center"
                                colspan="3"
                                :key="d.id"
                                >{{ d | moment("MMMM") }}</b-th
                            >
                        </b-tr>
                    </template>
                </b-table>
            </div>
        </b-card-body>
    </b-card>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import moment from "moment";

export default {
  props: {
    range: String,
    isExport: Boolean
  },
  computed: {
    ...mapGetters({
      manufacturerStats: "analytics/getManufacturerStatsData"
    }),
    ...mapState({
      loading: state => state.analytics.loading.manufacturerStats
    }),
    fields() {
      let fields = [
        {
          key: "manufacturer_name",
          label: "",
          tdClass: "col-manufacturer-name font-weight-bold"
        }
      ];

      if (this.manufacturerStats.dates === undefined) {
        return fields;
      }

      this.manufacturerStats.dates.forEach(d => {
        let date = moment(d).format("YYMM");
        fields.push(
          {
            key: `${date}.pass`,
            label: "Pass",
            tdClass: "col-pass"
          },
          {
            key: `${date}.fail`,
            label: "Fail",
            tdClass: "col-fail"
          },
          {
            key: `${date}.ratio`,
            label: "Ratio",
            tdClass: "col-percent"
          }
        );
      });

      return fields;
    },
    items() {
      if (this.manufacturerStats.items === undefined) {
        return [];
      }

      let items = [];
      this.manufacturerStats.items.forEach(d => {
        let item = {
          manufacturer_name: d.manufacturer_name
        };
        d.data.forEach(i => {
          let date = moment(i.date).format("YYMM");
          item[date] = {
            pass: i.pass_count > 0 ? this.formatNumber(i.pass_count) : null,
            fail: i.fail_count > 0 ? this.formatNumber(i.fail_count) : null,
            ratio: i.pass_rate > 0 ? this.formatPercentage(i.pass_rate) : null
          };
        });
        items.push(item);
      });
      return items;
    }
  },
  data() {
    return {
      timeframes: ["6 months", "1 year"],
      selectedTimeframe: "6 months"
    };
  },
  watch: {
    selectedTimeframe: {
      handler(value) {
        value = value.replace(/\s/g, "");
        let timeframe = "?timeframe=" + value;
        this.getManufacturerStats(timeframe);
      },
      deep: true
    }
  },
  mounted() {
    if (!this.isExport) {
      let value = this.selectedTimeframe.replace(/\s/g, "");
      let timeframe = "?timeframe=" + value;
      this.getManufacturerStats(timeframe);
    }
  },
  methods: {
    ...mapActions({
      getManufacturerStats: "analytics/getManufacturerStats"
    }),
    formatNumber(int) {
      return new Intl.NumberFormat().format(int);
    },
    formatPercentage(int) {
      return int.toFixed(1) + "%";
    }
  }
};
</script>

<style scoped>
h4 {
  margin-top: 0.5rem;
}

.row-months th {
  background-color: #1b1b9f;
  color: white;
}

.table thead th {
  border-top: 1px solid #dee2e6;
}
</style>
